export default class BaseRuleSetProcessor {
    async process(
        gameContext,
        eventConfiguration,
        sportData,
        event = () => {
            throw new Error("Event is required");
        }
    ) {
        const { ruleSetContext, changes } = await this._process(
            gameContext,
            eventConfiguration,
            sportData,
            event
        );
        console.info(
            "Applied rules: ",
            sportData?.play?._state?.history,
            ruleSetContext.appliedRules
        );
        return changes;
    }

    async _process() {
        throw Error("Not implemented");
    }

    async _processTree(
        node,
        gameContext,
        ruleContext,
        eventConfiguration,
        sportData,
        event
    ) {
        let changes = [];

        //depth first processing
        const rule = node?.getObject();

        if (
            rule &&
            rule.applicable(
                gameContext,
                ruleContext,
                eventConfiguration,
                sportData,
                event
            )
        ) {
            ruleContext.appliedRules.push(rule.constructor.name);
            changes =
                (await rule.apply(
                    gameContext,
                    ruleContext,
                    eventConfiguration,
                    sportData,
                    event
                )) || [];
            const children = node.getChildren();
            for (const child of children) {
                let childChanges = await this._processTree(
                    child,
                    gameContext,
                    ruleContext,
                    eventConfiguration,
                    sportData,
                    event
                );

                changes = changes.concat(childChanges);
            }
        }

        return changes;
    }
}
